import type { TouchpointCreateRequestClassesItem } from "generated/schemas";

import { toUpperCaseSpacesToUnderScores } from "utilities";

export const formatTouchpointClassesForApi = (
  classes: string[] | undefined,
): TouchpointCreateRequestClassesItem[] =>
  (classes ?? []).map(
    (studentClass) =>
      toUpperCaseSpacesToUnderScores(studentClass) as TouchpointCreateRequestClassesItem,
  );

export const filterTouchpointClassesByAllowedTypes = (
  classes: string[] | undefined,
  allowedClassTypes: { name: string }[],
): string[] => {
  const allowed = new Set(allowedClassTypes.map((type) => type.name));
  return (classes ?? []).filter((classType) => allowed.has(classType));
};
